export const MOVE_DIRECTIONS = ['up', 'down', 'left', 'right']
export const SIZE = 4
export const NUM_TILES = SIZE * SIZE
export const EMPTY_INDEX = NUM_TILES - 1
export const SHUFFLE_MOVES_RANGE = [100, 120]
